module.exports = __webpack_public_path__ + "static/media/trans-excution.54d5755d.svg";